export { default } from './notes-of-the-week';
